// import * as mttTypes from '@/store/mutationTypes'
// import {devMntAPI} from '@/api/restfulAPI'
import {systemSettingAPI} from '@/api/restfulAPI'

const state = {
  productConfig: {
    product_name: "",
    login_page_title_use_text: false,
    login_page_title: "",
    login_page_subtitle: "",
    login_page_title_image: "",
    login_page_title_logo_image: "",
    login_page_background: "",
    login_page_background_1280: "",
    login_page_background_1920: "",
    login_page_background_max: "",
    main_logo_image: "",
    main_logo_title: "",
    power_by_logo: "",
    watermark_logo: "",
    product_favicon: "",
    pageTitle: "",
    go_to_forum: true,
    go_to_document: true,
    show_forget_pwd: true
  }
}

const getters = {
  devInfos: state => {
    return state.productConfig
  }
}

const mutations = {
  setProductConfig (state, productConfig) {
    state.productConfig = productConfig
  }
}

const actions = {
  getGroupInfos ({commit, state}) {
    // let groupInfos = []
    // devMntAPI.getGroupInfos(null, null, null).then(data => {
    //   groupInfos = data.data
    //   commit(mttTypes.GET_GROUP_INFOS, groupInfos)
    // }).catch(error => {
    //   console.log(error)
    // })
  },
  getProductConfig ({commit, state}, orgId) {
    systemSettingAPI.getProductConfig(orgId).then(res => {
      commit('setProductConfig', res)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/productInfo.js